import { render } from "./HorekaReport.vue?vue&type=template&id=3b01db38"
import script from "./HorekaReport.vue?vue&type=script&lang=js"
export * from "./HorekaReport.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\tabarok_management\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__